import React from 'react';
import { useState, Fragment } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UploadRuleSet from './upload-rule-set';
import ConfigureRuleSet from './configure-rule-set';
import SearchtheRules from './search-the-rules';
import { TypeAnimation } from 'react-type-animation';
import UpdateMasterData from './update-master-data';
const RuleSetManagement = () => {
    const [key, setKey] = useState('uploadruleset');
    const renderTabTitle = (tabKey, title) => {
        if (key === tabKey) {
            return (
                <span className="fixed-tab-title">
                    <TypeAnimation
                        sequence={[title]}
                        speed={40}
                        wrapper="span"
                        cursor={false}
                        repeat={0}
                        key={key}
                    />
                </span>
            );
        }
        return <span className="fixed-tab-title">{title}</span>;
    };
    return (
        <Fragment>
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                unmountOnExit
            >
                <Tab eventKey="uploadruleset" className='uploadruleset' title={renderTabTitle('uploadruleset', 'Upload Rule Set')}>
                    <UploadRuleSet />
                </Tab>
                <Tab eventKey="configureruleset" className='configureruleset' title={renderTabTitle('configureruleset', 'Configure Rule Set')}>
                    <ConfigureRuleSet />
                </Tab>
                <Tab eventKey="updatemasterdata" className='updatemasterdata' title={renderTabTitle('updatemasterdata', 'Update Master Json')}>
                    <UpdateMasterData />
                </Tab>
                <Tab eventKey="searchtherules" title={renderTabTitle('searchtherules', 'Search the Rules')}>
                    <SearchtheRules />
                </Tab>
            </Tabs>
        </Fragment>
    );
};

export default RuleSetManagement;